import { render, staticRenderFns } from "./consulta_campo_radio.vue?vue&type=template&id=57b900ba&scoped=true&"
import script from "./consulta_campo_radio.vue?vue&type=script&lang=js&"
export * from "./consulta_campo_radio.vue?vue&type=script&lang=js&"
import style0 from "./consulta_campo_radio.vue?vue&type=style&index=0&id=57b900ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b900ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
